import * as React from 'react'
import { FieldModel } from 'typings/api-models/creditCheck'
import Label from './label'

export default class TextInput extends React.Component<TextInputProps> {
  public buildContainerClassName(): string {
    let className = 'form-group formGroup validate'
    className = className + (this.props.field.valid ? ' valid' : ' invalid')
    className = className + (this.props.field.touched ? ' touched' : ' untouched')
    className = className + ' ' + this.props.className
    return className
  }

  public render(): JSX.Element {
    const { field, handleChange, disabled } = this.props
    return (
      <div className={this.buildContainerClassName()}>
        <Label className="control-label">{field.label}{field.required ? '*' : ''}<span className="warning-icon icon" /></Label>
        <input 
          type="text" 
          name={field.name} 
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleChange(field, e) }} 
          value={field.value}
          autoComplete="off"
          disabled={disabled}
          className="form-control"
          id={this.props.id}
        />
      </div>
    )
  }
}

/* tslint:disable no-any */
interface TextInputProps extends React.AllHTMLAttributes<HTMLInputElement> {
  field: FieldModel<string>
  handleChange: any
}
/* tslint:enable no-any */



// WEBPACK FOOTER //
// ./src/components/_atoms/input.tsx